import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { trackEvent } from './analytics';

const BEER_IMAGE_URL =
    'https://images.unsplash.com/photo-1608270586620-248524c67de9?auto=format&fit=crop&w=900&q=80';
const BEER_PHOTO_PAGE = 'https://unsplash.com/photos/sliced-lemon-beside-clear-glass-bottle-3lGi0BXJ1W0';
const BEER_PHOTOGRAPHER = 'Manki Kim';

const YOUTUBE_VIDEO_ID = 'videoseries?si=t5yy8LVRjH9qKnKm&list=OLAK5uy_nnz5zKudUtncqbfaIQZtX1NeKP6TUHJAg';

const CONFETTI_COLORS = ['#FFD700', '#FF6B6B', '#4da3ff', '#50C878', '#FF69B4', '#FFA500', '#FFFFFF'];
const CONFETTI_ITEMS = Array.from({ length: 32 }, (_, i) => ({
    id: i,
    left: ((i * 3.77 + 2.3) % 100).toFixed(1),
    delay: ((i * 0.41) % 4).toFixed(2),
    duration: (3 + (i * 0.31) % 2.5).toFixed(2),
    color: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
    size: 5 + (i * 2) % 9,
    circle: i % 3 === 0,
}));

function Confetti() {
    return (
        <div className="confetti-container" aria-hidden="true">
            {CONFETTI_ITEMS.map(p => (
                <div
                    key={p.id}
                    className="confetti-piece"
                    style={{
                        left: `${p.left}%`,
                        animationDelay: `${p.delay}s`,
                        animationDuration: `${p.duration}s`,
                        background: p.color,
                        width: `${p.size}px`,
                        height: `${p.size}px`,
                        borderRadius: p.circle ? '50%' : '2px',
                    }}
                />
            ))}
        </div>
    );
}

async function downloadImage(url, filename) {
    try {
        const res = await fetch(url);
        const blob = await res.blob();
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(blobUrl);
    } catch {
        window.open(url, '_blank');
    }
}

export default function FreeBeerPage() {
    const [embedOpacity, setEmbedOpacity] = useState(0.7);

    React.useEffect(() => {
        trackEvent('page_view', 'free_beer');
    }, []);

    const ytSrc =
        `https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}` +
        `&autoplay=1&mute=1&enablejsapi=1&origin=${encodeURIComponent(window.location.origin)}`;

    return (
        <div className="loc-page fade-in">
            <Confetti />

            {/* Back nav */}
            <div className="nav-header">
                <Link to="/" className="back-link">← Back</Link>
            </div>

            {/* Hero */}
            <section className="loc-hero">
                <div className="loc-badge loc-badge--beer">📍 free_beer</div>
                <h1 className="loc-title">
                    You Won! 🎉
                </h1>
                <p className="loc-lucky">Today must be your lucky day!</p>
                <p className="loc-subtitle">
                    You found this spot — enjoy the view below.
                </p>
            </section>

            {/* Image */}
            <section className="loc-image-section">
                <div className="loc-image-frame">
                    <img
                        src={BEER_IMAGE_URL}
                        alt="Cold Modelo beer"
                        className="loc-hero-img"
                        loading="eager"
                    />
                    <div className="loc-image-glow loc-image-glow--gold" />
                </div>
                <div className="loc-image-caption">
                    <span>🎁 Your free item is this photo — download and keep it.</span>
                    <button
                        className="loc-download-btn"
                        onClick={() => downloadImage(BEER_IMAGE_URL, 'free-beer.jpg')}
                    >
                        ⬇ Download
                    </button>
                </div>
                <p className="loc-photo-credit">
                    Photo by{' '}
                    <a href={BEER_PHOTO_PAGE} target="_blank" rel="noopener noreferrer">
                        {BEER_PHOTOGRAPHER}
                    </a>{' '}on Unsplash
                </p>
            </section>

            {/* YouTube Embed Section */}
            <section className="loc-embed-section fade-in">
                <div className="loc-embed-label">Now Playing: MELTDOWN Playlist</div>

                <div className="loc-opacity-controls">
                    <label htmlFor="opacity-slider">Video Opacity: {Math.round(embedOpacity * 100)}%</label>
                    <input
                        id="opacity-slider"
                        type="range"
                        min="0"
                        max="1"
                        step="0.01"
                        value={embedOpacity}
                        onChange={(e) => setEmbedOpacity(parseFloat(e.target.value))}
                        className="loc-opacity-slider"
                    />
                </div>

                <div className="loc-embed-frame" style={{ opacity: embedOpacity }}>
                    <iframe
                        width="100%"
                        height="450"
                        src={ytSrc}
                        title="YouTube playlist player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    ></iframe>
                </div>
            </section>
        </div>
    );
}
